import { type MetaFunction } from '@remix-run/node'
import sterling from './sterling.png'

export const meta: MetaFunction = () => [
	{ title: 'Sterling Insurance Company' },
	{
		name: 'description',
		content:
			'We offer insurance from Sterling Insurance Company and Sterling Coop.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Sterling</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img src={sterling} alt="Sterling Insurance Company" className="w-64" />
				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Since 1895, the mission of Sterling Insurance Company has been to
					provide sound insurance protection and excellent service to its
					policyholders.
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Sterling's products include homeowner, automobile, farm owner,
					landlord, umbrella, mobile homeowner, tenant, business owner's,
					commercial liability, and commercial property.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					A.M. Best awarded Sterling with the financial rating of A (Excellent)
					based on their excellent ability to meet ongoing obligations to
					policyholders.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.sterlingins.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.sterlingins.com/ (opens in a new tab)
					</a>
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Sterling Online Payment"
						href="https://www.sterlingagents.com/AllPoints/billingccquery.html"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.sterlingagents.com/AllPoints/billingccquery.html (opens
						in a new tab)
					</a>
					<br />
					<br />
					Billing Address:
					<br />
					PO Box 9<br />
					Cobleskill, NY 12043
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Sterling Insurance Company
					<br />
					182 Barnerville Rd
					<br />
					Cobleskill, NY 12043
				</p>
			</section>
		</main>
	)
}
